/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetActiveJobsByDriverIdAdminResponse } from '../models/GetActiveJobsByDriverIdAdminResponse';
import type { GetDriverEstimatedRouteEtaResponse } from '../models/GetDriverEstimatedRouteEtaResponse';
import type { GetJobShipmentsInfoResponseAdmin } from '../models/GetJobShipmentsInfoResponseAdmin';
import type { GetJobShipmentsMonitoringRoutesResponseAdmin } from '../models/GetJobShipmentsMonitoringRoutesResponseAdmin';
import type { GetLiveJobsDriverResponse } from '../models/GetLiveJobsDriverResponse';
import type { GetMonitoringJobsResponseAdmin } from '../models/GetMonitoringJobsResponseAdmin';
import type { JobStatus } from '../models/JobStatus';
import type { MonitoringJobAdminDto } from '../models/MonitoringJobAdminDto';
import type { Pagination1OfJobAdminListedDto } from '../models/Pagination1OfJobAdminListedDto';
import type { ShipmentStatus } from '../models/ShipmentStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobsService {
    /**
     * @returns GetLiveJobsDriverResponse OK
     * @throws ApiError
     */
    public static getLiveJobsDriver(): CancelablePromise<GetLiveJobsDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/jobs/live',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverEstimatedRouteEtaResponse OK
     * @throws ApiError
     */
    public static getDriverEstimatedRouteDriver({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<GetDriverEstimatedRouteEtaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/jobs/{jobId}/driver-estimated-route',
            path: {
                'jobId': jobId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewJobs`
     * @returns GetActiveJobsByDriverIdAdminResponse OK
     * @throws ApiError
     */
    public static getActiveJobsByDriverIdAdmin({
        driverId,
    }: {
        driverId: number,
    }): CancelablePromise<GetActiveJobsByDriverIdAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/jobs/active/driver/{driverId}',
            path: {
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetDriverEstimatedRouteEtaResponse OK
     * @throws ApiError
     */
    public static getDriverEstimatedRouteAdmin({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<GetDriverEstimatedRouteEtaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/jobs/{jobId}/driver-estimated-route',
            path: {
                'jobId': jobId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetJobShipmentsMonitoringRoutesResponseAdmin OK
     * @throws ApiError
     */
    public static getShipmentsMonitoringRoutesAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetJobShipmentsMonitoringRoutesResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/jobs/{id}/shipments/routes/monitoring',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewJobs`
     * @returns Pagination1OfJobAdminListedDto OK
     * @throws ApiError
     */
    public static getJobsAdmin({
        regionId,
        statuses,
        driverId,
        branchId,
        fromDate,
        toDate,
        page,
        limit,
    }: {
        regionId?: number,
        statuses?: Array<JobStatus>,
        driverId?: number,
        branchId?: number,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfJobAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/jobs',
            query: {
                'regionId': regionId,
                'statuses': statuses,
                'driverId': driverId,
                'branchId': branchId,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetMonitoringJobsResponseAdmin OK
     * @throws ApiError
     */
    public static getMonitoringJobsAdmin({
        regionIds,
        channelIds,
        fetchAll,
        shipmentStatuses,
    }: {
        regionIds: Array<number>,
        channelIds: Array<number>,
        fetchAll?: boolean,
        shipmentStatuses?: Array<ShipmentStatus>,
    }): CancelablePromise<GetMonitoringJobsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/jobs/monitoring',
            query: {
                'fetchAll': fetchAll,
                'regionIds': regionIds,
                'channelIds': channelIds,
                'shipmentStatuses': shipmentStatuses,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns MonitoringJobAdminDto OK
     * @throws ApiError
     */
    public static getMonitoringJobAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<MonitoringJobAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/jobs/{id}/monitoring',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns GetJobShipmentsInfoResponseAdmin OK
     * @throws ApiError
     */
    public static getJobShipmentsDataAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetJobShipmentsInfoResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/jobs/{id}/shipment-info',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
